import { makeStyles } from "@mui/styles"
import { colors } from "../../utils"

const useStyles = makeStyles(() => ({
  pqrTitle: {
    color: colors.primary,
    "&.MuiTypography-root": {
      fontWeight: "bold",
    },
  },

  pqrSubtitle: {
    color: colors.primary,
  },
}))

export default useStyles
